import { useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Messages } from 'primereact/messages';
import { AddUserForm, Inputs } from './form';
import { useAddUser } from '../../../services/mutations';

function DialogFooter({ onCancel = () => {}, onSubmit = () => {}, submitting = false }) {
  return (
    <div>
      <Button label="Cancel" onClick={onCancel} size="small" text />
      <Button label="Submit" loading={submitting} onClick={onSubmit} size="small" />
    </div>
  );
}

function AddUserModal({ open = false, onClose = () => {} }) {
  const resultToast = useRef<Toast>(null);
  const messages = useRef<Messages>(null);
  const formRef = useRef<HTMLFormElement>(null);
  const addUser = useAddUser();

  const closeModal = () => {
    onClose();
    formRef.current?.reset();
    addUser.reset();
  };

  const submit = () => formRef.current?.requestSubmit();

  const handleSubmit = (data: Inputs) => {
    messages.current?.clear();

    const user = {
      email: data.user.mail,
      name: data.user.givenName,
      familyName: data.user.surname,
      isAdmin: data.isAdmin,
      isActive: data.isActive,
      roles: data.roles,
    };

    addUser.mutate(user, {
      onSuccess: () => {
        resultToast.current?.show({
          severity: 'success',
          summary: 'New user',
          detail: 'User was successfully created.',
          life: 3000,
        });
        closeModal();
      },
      onError: () => {
        messages.current?.show({ severity: 'error', summary: 'Unable to add user', sticky: true });
      },
    });
  };

  const handleCancel = () => {
    closeModal();
  };

  return (
    <>
      <Toast ref={resultToast} />
      <Dialog
        header="Add new user"
        onHide={handleCancel}
        footer={<DialogFooter onCancel={handleCancel} onSubmit={submit} submitting={addUser.isLoading} />}
        visible={open}
        breakpoints={{ '600px': '100vw' }}
        style={{ width: '600px' }}
        modal
      >
        <Messages ref={messages} />
        <AddUserForm onSubmit={handleSubmit} ref={formRef} />
      </Dialog>
    </>
  );
}

export default AddUserModal;
